export default __webpack_public_path__ + "static/char-v-34-ja-29b684444e76ce0b4abd8daab4912563.mp4";